import React, { useEffect } from 'react'
import { Input, Form, Space } from 'antd'
import { GraviButton } from '@gravitate-js/excalibrr'
import { useWizardMaster } from '@components/OrderWizard/Contexts/WizardMasterContext'

export const OrderNoteForm = () => {
  const { setViewingNoteForm, driverNote, form, saveDriverNote } = useWizardMaster()

  return (
    <div>
      <Form className='p-3' onFinish={saveDriverNote} form={form}>
        <Form.Item name='content' className='mt-3'>
          <Input.TextArea allowClear rows={3} maxLength={130} showCount />
        </Form.Item>
        <div align='right'>
          <Space>
            <Form.Item>
              <GraviButton
                buttonText='Cancel'
                appearance='outline'
                onClick={() => {
                  if (!driverNote) {
                    form.resetFields()
                  }
                  setViewingNoteForm(false)
                }}
              />
            </Form.Item>
            <Form.Item>
              <GraviButton buttonText='Save' theme2 htmlType='submit' />
            </Form.Item>
          </Space>
        </div>
      </Form>
    </div>
  )
}
